import { useState } from 'react';

export const useInfiniteScroll = () => {

    const [disableInfiniteScroll, setDisableInfiniteScroll] = useState(false);
    const [showInfiniteScroll, setShowInfiniteScroll] = useState(true);

    return {
        disableInfiniteScroll,
        setDisableInfiniteScroll,
        showInfiniteScroll, 
        setShowInfiniteScroll
    };
}
